import { render, staticRenderFns } from "./contactgegevens.vue?vue&type=template&id=ea8ddbe6&scoped=true"
import script from "./contactgegevens.vue?vue&type=script&lang=js"
export * from "./contactgegevens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8ddbe6",
  null
  
)

export default component.exports